/** Erro de regra do convite: a mensagem é mostrada como está para o usuário. */
export class InviteActionError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "InviteActionError";
  }
}
